import { ElMessageBox, ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message-box/style/css';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import { computed, reactive } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ACCESS_TOKEN, USERINFO } from "@/store/mutation-types";
import apis from "@/api";
export default {
  components: {},
  setup() {
    const store = useStore();
    const router = useRouter();
    const data = reactive({
      user: {}
    });
    const userInfo = computed(() => {
      const userInfo = window.localStorage.getItem(USERINFO);
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      data.user = JSON.parse(userInfo) || {};
      return data.user;
    });
    const subDepName = computed(() => {
      const depName = data.user.depName;
      if (depName) {
        return depName.substring(depName.lastIndexOf("/") + 1, depName.length);
      }
      return null;
    });
    const logout = () => {
      ElMessageBox.confirm("确定要退出吗？", "提示").then(() => {
        apis.logout().then(res => {
          console.log('logout', res);
          if (res.success) {
            window.localStorage.removeItem(ACCESS_TOKEN);
            window.localStorage.removeItem(USERINFO);
            router.push("/login");
            window.location.reload();
          } else {
            ElMessage.error(res.msg);
          }
        });
      }).catch(err => {
        console.error(err);
      });
    };
    const goNewPage = () => {
      window.open('http://10.173.23.48:8199/xwtecsvc/assets/home/index');
    };
    return {
      userInfo,
      subDepName,
      logout,
      goNewPage
    };
  }
};